/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListWorkHour } from '../models/api-response-list-work-hour';
import { createOrUpdateListOfWorkHour } from '../fn/work-hour-api/create-or-update-list-of-work-hour';
import { CreateOrUpdateListOfWorkHour$Params } from '../fn/work-hour-api/create-or-update-list-of-work-hour';
import { listWorkHour } from '../fn/work-hour-api/list-work-hour';
import { ListWorkHour$Params } from '../fn/work-hour-api/list-work-hour';

@Injectable({ providedIn: 'root' })
export class WorkHourApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createOrUpdateListOfWorkHour()` */
  static readonly CreateOrUpdateListOfWorkHourPath = '/v1/api/ui/work-hour/create-update-list/{refPhoneCompany}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateListOfWorkHour()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrUpdateListOfWorkHour$Response(params: CreateOrUpdateListOfWorkHour$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListWorkHour>> {
    return createOrUpdateListOfWorkHour(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateListOfWorkHour$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrUpdateListOfWorkHour(params: CreateOrUpdateListOfWorkHour$Params, context?: HttpContext): Observable<ApiResponseListWorkHour> {
    return this.createOrUpdateListOfWorkHour$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListWorkHour>): ApiResponseListWorkHour => r.body)
    );
  }

  /** Path part for operation `listWorkHour()` */
  static readonly ListWorkHourPath = '/v1/api/ui/work-hour/list/{refPhoneCompany}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listWorkHour()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkHour$Response(params: ListWorkHour$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListWorkHour>> {
    return listWorkHour(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listWorkHour$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkHour(params: ListWorkHour$Params, context?: HttpContext): Observable<ApiResponseListWorkHour> {
    return this.listWorkHour$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListWorkHour>): ApiResponseListWorkHour => r.body)
    );
  }

}
